<script lang="ts">
  export let width: number;

  import OneCaneFromLib from "./OneCaneFromLib.svelte";

  const canes = [
    'bigRed',
    'bigRedWithYellowFlower',
    'blackAndRed',
    'dentWhiteYellowCore',
    'doubleWhiteAndDarkBlue',
    'redWithGreenScatter',
    'twoWhiteAndFourMiddle',
    'whiteDentOrangeCross',
    'yellowAndBlue',
  ];

</script>

<table>
  <thead>
    <tr>
      <th scope="col">Original</th>
      <th scope="col">Generated</th>
    </tr>
  </thead>
  <tbody>
    {#each canes as caneName}
      <tr>
        <td>
          <img {width} src="img/reals/{caneName}.png" alt="a reference cane" />
        </td>
        <td>
          <OneCaneFromLib nameInlib={caneName} size={width} />
        </td>
      </tr>
    {/each}
  </tbody>
</table>
